mutation UpdateChurnInfo($input: ChurnInfoUpdateInput!) {
    churnInfoUpdate(input: $input) {
        churnInfo {
            selectedReasons
            additionalComments
            userName
            userEmail
        }
    }
}
